import { parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

export type StockExchange = {
  code: string;
  country_id: number | null;
  country_code: string | null;
  en_translation: string | null;
  fr_translation: string | null;
  city: string | null;
  mic: string | null;
  created_at: string;
  updated_at: string;
};

export const stock_exchanges_columns: ColumnDef<StockExchange>[] = [
  {
    accessorKey: "code",
    header: "Code",
  },
  {
    accessorKey: "country_code",
    header: "Country",
    cell: ({ row }) => {
      const countryCode = row.getValue("country_code") as string | null;
      const countryId = row.original.country_id;
      if (!countryCode || !countryId) return null;
      return (
        <Link
          href={toWorkspacePath(
            `/admin/qtl - referential/countries/${countryId}`,
          )}
          className="text-xs"
          underline="hover"
        >
          {countryCode}
        </Link>
      );
    },
  },
  {
    accessorKey: "en_translation",
    header: "EN Translation",
  },
  {
    accessorKey: "fr_translation",
    header: "FR Translation",
  },
  {
    accessorKey: "city",
    header: "Ville",
  },
  {
    accessorKey: "mic",
    header: "MIC",
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue("created_at")),
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => parseDate(row.getValue("updated_at")),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      const code = row.getValue("code");
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${code}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
